<template>
  <form-panel
    width="short"
    title="Nueva tarea"
    @closePanel="onCloseModal">
    <tasks-form
      :old="oldTask"
      :customer="customer"/>
  </form-panel>
</template>
<script>
import FormPanel from '@/components/_shared/form-panel'
import TasksForm from '@/modules/tasks/tasks-form'

export default {
  name: 'TasksCreateView',
  components: {
    FormPanel,
    TasksForm
  },
  provide () {
    return {
      trackings: this.trackings
    }
  },
  props: {
    old: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      oldTask: null
    }
  },
  computed: {
    trackings () {
      return this.$store.getters['trackings/items']
    },
    customer () {
      if (this.$route.name === 'customers-task-table') {
        return this.$store.getters['customers/item']
      }
      return null
    }
  },
  mounted () {
    this.oldTask = this.isEdit ? this.old : null
  },
  methods: {
    onCloseModal () {
      this.$emit('closeEdition', false)
      this.$store.dispatch('app/toggleTasksPanel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/app/tasks/tasks-create-view.vue